<template>
    <div class="footer">
        <div class="footer_container">
            <div class="company_info">
                <a-space align="center" :size="10">
                    <span>&copy; 91家纺网</span>
                    <a href="https://detail.91jf.com/about" target="_blank">关于我们</a>
                    <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备12003642号</a>
                </a-space>
            </div>
            <div class="img_down_app img_wrapper">
            <img src="~@/assets/images/login/down_app.png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginFooter',
}
</script>

<style scoped>
.footer {
    width: 100%;
    height: 166px;
    background: #f7f7f7;
}

.footer .footer_container {
    width: 90%;
    /* max-width: 1190px; */
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.img_down_app{
    width: 260px;
    height: 123px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/LoginFooter.vue